import APIMapper from './APIMapper';
import ConnectionController from "../../controllers/ConnectionsController";
import * as EntityTypes from '../constants/entityTypes';

class AudienceAPIMapper extends APIMapper {
  async update(change) {
    const { item, onSuccess, onError } = change;
    try {
      const company = item.dependencies.get(EntityTypes.COMPANY);
      const response = await ConnectionController.putWebhook(item.nextValue, company);
      onSuccess(response)
    } catch (e) {
      onError(e);
    }
  }
}

export default new AudienceAPIMapper();
